import CommonChip from "commonComponents/CommonChip";
import { APP_ENV_TYPES, currentAppEnv, isProdEnv } from "data/env-constants";

const ENV_BADGE_COLORS: Record<string, string> = {
  [APP_ENV_TYPES.LOCAL]: "bg-gray-500",
  [APP_ENV_TYPES.DEV]: "bg-purple-500",
  [APP_ENV_TYPES.STAGING]: "bg-amber-500",
  [APP_ENV_TYPES.PREPROD]: "bg-blue-500",
  [APP_ENV_TYPES.BETA]: "bg-pink-500",
};

export default function EnvBadge({ customClass = "" }: { customClass?: string }) {
  if (isProdEnv) return null;

  return (
    <CommonChip
      text={currentAppEnv.toUpperCase()}
      customClass={`${ENV_BADGE_COLORS[currentAppEnv]} ${customClass}`}
    />
  );
}
